/* Core & libraries */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import moment from 'helpers/moment';
import { Link } from 'react-router-dom';
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { nameInitials } from "../../../../helpers/general";

/* Components */
import { ReactComponent as ChoiceFeaturedIcon } from '../../../../resources/images/choice-trips-featured-icon.svg';
import { ReactComponent as PlusSign } from '../../../../resources/images/plus.svg';

import styles from "./styles.js"

export const HotelTypeColumns = ({ globalLocale, displayBookingInfoModal, displayInviteGuestModal }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const getStatus = (type) => {
    switch (type?.toUpperCase()) {
      case 'CHECKED_IN':
        return (
          <div className={classes['checkedin']}>
            <FormattedMessage id={'safetyGridChoice.checkedin'} />
          </div>
        );
      case 'CHECKED_OUT':
        return (
          <div className={classes['checkedout']}>
            <FormattedMessage id={'safetyGridChoice.checkedout'} />
          </div>
        );
      case 'RESERVED':
        return (
          <div className={classes['upcoming']}>
            <FormattedMessage id={'safetyGridChoice.reserved'} />
          </div>
        );
      case 'CANCELLED':
        return (
          <div className={classes['canceled']}>
            <FormattedMessage id={'safetyGridChoice.cancelled'} />
          </div>
        );
      case 'NO_SHOW':
        return (
          <div className={classes['canceled']}>
            <FormattedMessage id={'safetyGridChoice.noshow'} />
          </div>
        );
      default:
        return null;
    }
  };
  
  return {
    bookingInfo: (row) => {
      const name = `${row.firstName} ${row.lastName}`;
      return (
        <Link onClick={() => displayBookingInfoModal(row)} className={classes.link}>
          <div className={classes.nameWrapper} tabIndex={0}>
            <div className={classes.featuredIconStyle}>
              <ChoiceFeaturedIcon />
            </div>

            <div className={classes.details}>
              <div className={classes.detailsWrapper}>
                <span className={classes.name}>{row.hotelName || '-'}</span>

                {row?.guestBooking && (
                  <span className={classes.badge} onClick={(e) => displayInviteGuestModal(e, name)}>
                    <span className={classes.badgeText}>
                      <FormattedMessage id="safetyGrid.guest" />
                    </span>
                    <PlusSign />
                  </span>
                )}
              </div>

              <p>{(row.city && row.stateCode) ? `${row.city}, ${row.stateCode}` : '-'}</p>
            </div>
          </div>
        </Link>
      );
    },

    mainStatus: (row) => (
      <div onClick={() => displayBookingInfoModal(row)}>
        {getStatus(row.mainStatus)}
      </div>
    ),

    startDate: (row) => (
      <div className={classes.departureStatus} onClick={() => displayBookingInfoModal(row)}>
        <div className={classes.startDate}>{moment(row.startDate).locale(globalLocale).format('D MMM YYYY')}</div>
        {/* <div className={classes.startTime}>{moment(row.startDate).format('h A')}</div> */}
      </div>
    ),

    endDate: (row) => (
      <div className={classes.departureStatus} onClick={() => displayBookingInfoModal(row)}>
        <div className={classes.startDate}>{moment(row.endDate).locale(globalLocale).format('D MMM YYYY')}</div>
        {/* <div className={classes.startTime}>{moment(row.endDate).format('h A')}</div> */}
      </div>
    ),
    

    avatarName: (row) => {
      const name = `${row.firstName} ${row.lastName}`;

      return (
        <Link onClick={() => displayBookingInfoModal(row)} className={classes.link}>
          <div className={classes.nameWrapper} tabIndex={0}>
            <div className={classes.initialsAvatar}>
              <span>{nameInitials(name)}</span>
            </div>

            <div className={classes.details}>
              <div className={classes.detailsWrapper}>
                <span className={classes.name}>{name}</span>

                {row?.guestBooking && (
                  <span className={classes.badge} onClick={(e) => displayInviteGuestModal(e, name)}>
                    <span className={classes.badgeText}>
                      <FormattedMessage id="safetyGrid.guest" />
                    </span>
                    <PlusSign />
                  </span>
                )}
              </div>

              <p>{row?.emailAddress || '-'}</p>
            </div>
          </div>
        </Link>
      );
    },
    
  };
};